import { Stack, useTheme } from '@mui/system';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import strings from 'common/Translation/Translate';
import { FC } from 'react';
import { images } from 'utils/constants/images';

interface CompetitionHotelProps {
  competitions: Array<any>;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
}

const CompetitionsTable: FC<CompetitionHotelProps> = ({ competitions, onEdit, onDelete }: any) => {
  const theme = useTheme();

  const columns: GridColDef[] = [
    {
      field: 'hotelName',
      headerName: strings.sales_management_branch_competitions_column_hotel_name,
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'fitRoomNights',
      headerName: strings.sales_management_branch_competitions_column_fit_potential,
      flex: 1,
      minWidth: 100,
    },
    {
      field: 'miceNights',
      headerName: strings.sales_management_branch_competitions_column_mice_potential,
      flex: 1,
      minWidth: 100,
    },
    {
      field: 'Action',
      headerName: strings.customermgmt_column_action,
      sortable: false,
      flex: 1,
      minWidth: 150,
      align: 'right',
      headerAlign: 'right',
      renderCell: (ValueFormatterParams: any) => {
        return (
          <Stack direction="row" spacing={2}>
            <img
              src={images.editIcon}
              alt="edit"
              width="20px"
              height="20px"
              style={{ cursor: 'pointer' }}
              onClick={(e: any) => {
                e.stopPropagation();
                onEdit(ValueFormatterParams.row.id);
              }}
            />
            <img
              className={'cursor-pointer'}
              src={images.deleteIcon}
              alt="delete"
              width="20px"
              height="20px"
              style={{ cursor: 'pointer' }}
              onClick={(e: any) => {
                e.stopPropagation();
                onDelete(ValueFormatterParams.row.id);
              }}
            />
          </Stack>
        );
      },
    },
  ];

  const value =
    competitions?.length > 0 ? (
      <div style={{ width: '100%' }}>
        <div style={{ height: 300, width: '100%' }}>
          <DataGrid
            sx={{
              overflow: 'auto',
              '.MuiDataGrid-row': {
                cursor: 'pointer',
                ':hover': {
                  backgroundColor: `${theme.palette.primary.main}09}`,
                },
              },
              '.MuiDataGrid-columnHeaders': {
                backgroundColor: `${theme.palette.primary.main}35}`,
              },
            }}
            rowHeight={60}
            rows={competitions.map((item: any, idx: any) => ({
              ...item,
              // months: item.months.map((m: any) => m.label).join(', '),
              id: idx,
            }))}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            disableColumnMenu
            disableSelectionOnClick
            autoHeight
            hideFooter
          />
        </div>
      </div>
    ) : null;
  return value;
};

export default CompetitionsTable;
